import { memo, useState, useEffect, useCallback } from "react";
import Spinner from "../../components/Spinner.js";
import useSelectStyles from "../../components/styles/Select.js";
import { useSnackbar } from "../../utils/index.js";
import Form from "../../components/Form.js";
import { Typography, Box, } from "@mui/material";
import { getOwners, cancelEndMilkingPeriod } from "../../api/index.js";

const UpdateEndMilkingPeriod = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedOwners, setFetchedOwners] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);

    const classes = useSelectStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const { owners } = await getOwners();
            setFetchedOwners(owners);
            setOwnersDropdownValues(
                owners.map((owner) => ({
                    value: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                    text: `${owner?.lastName} ${owner?.firstName} - ${owner?.code}`,
                }))
            );
        } catch (err) {
            error(err);
        }
        setIsLoading(false);
    }, [error]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const cancelEndMilkPeriodFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
        },
        {
            customType: "date-picker",
            id: "startDate",
            type: "desktop",
            label: "Έναρξη Περιόδου Τοκετών",
            width: "595px",
            background: "third",
            required: true,
        },
        {
            customType: "date-picker",
            id: "endDate",
            type: "desktop",
            label: "Λήξη Περιόδου Τοκετών",
            width: "595px",
            background: "third",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή",
        },
    ];

    const handleFormSubmit = async (values) => {
        setIsLoading(true);
        const selectedOwnerObj = fetchedOwners.find((owner) => `${owner?.lastName} ${owner?.firstName} - ${owner?.code}` === values.owner);
        const valuesToSend = {
            ownerId: selectedOwnerObj?._id,
            startDate: values?.startDate,
            endDate: values?.endDate,
        };
        try {
            const { success: scs, message } = await cancelEndMilkingPeriod(valuesToSend)
            if (scs) {
                success(message);
            } else {
                error(message);
            }
        } catch (err) {
            error(err)
        }
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h5" sx={{ margin: "1rem" }}>
                        Διόρθωση Λήξης Γαλακτοπαραγωγής
                    </Typography>
                    <Form
                        content={cancelEndMilkPeriodFormContent}
                        onSubmit={handleFormSubmit}
                        toResetForm={true}
                    />
                </Box>
            </Box>
        </>
    )
}

export default memo(UpdateEndMilkingPeriod)